export const CONFIRM_BUTTON_YES_KEY = 'ModalDialog_ConfirmDialog_Yes'
export const CONFIRM_BUTTON_NO_KEY = 'ModalDialog_ConfirmDialog_No'
export const CONFIRM_BUTTON_CANCEL_KEY = 'ModalDialog_ConfirmDialog_Cancel'
